/**
 * The Tonight greeting: "Good evening, Leo" / "Boa noite, Leo" — or, with no
 * name to use, the weekday + part of day ("Wednesday evening" / "Quarta à
 * noite").
 */

import { tForLocale, type Locale } from '@/i18n/locale';

export function partOfDay(date: Date): 'morning' | 'afternoon' | 'evening' {
  const hour = date.getHours();
  if (hour >= 5 && hour < 12) return 'morning';
  if (hour >= 12 && hour < 18) return 'afternoon';
  return 'evening';
}

/** The short weekday name: "Wednesday", "Quarta" (pt-BR drops "-feira"). */
export function weekdayName(date: Date, locale: Locale): string {
  // Late night (before 5am) still belongs to the previous evening.
  const day = new Date(date);
  if (day.getHours() < 5) day.setDate(day.getDate() - 1);
  const raw = day.toLocaleDateString(locale === 'pt-BR' ? 'pt-BR' : 'en-US', { weekday: 'long' });
  const name = raw.replace(/-feira$/i, '');
  return name.charAt(0).toUpperCase() + name.slice(1);
}

export function tonightGreeting(date: Date, locale: Locale): string {
  return tForLocale(locale, `tonight.greeting.${partOfDay(date)}`, {
    day: weekdayName(date, locale),
  });
}

/** The h1: a time-of-day hello by first name, else the weekday line. */
export function homeGreeting(date: Date, locale: Locale, displayName?: string | null): string {
  const first = displayName?.trim().split(/\s+/)[0];
  if (!first) return tonightGreeting(date, locale);
  return tForLocale(locale, `tonight.hello.${partOfDay(date)}`, { name: first });
}
